import { createSelector, createStructuredSelector } from 'reselect'
import { Map } from 'immutable'
import { getInOr, safeToJS, getOr } from 'utils/immutable'
import { path } from 'ramda'
import { mergeConditionWithSignal } from 'selectors/feature/conditions'
import { getInputDescriptions, signalsSelector } from 'selectors/feature/inputs'

const scalingQuerySelector = (state, props) =>
  getInOr(Map(), ['feature', 'currentFeature', 'conditions', props.uri], state)

const scalingQueryWithSignalSelector = createSelector(
  scalingQuerySelector,
  signalsSelector,
  getInputDescriptions,
  (_, props) => props,
  (query, signals, inputDescriptions, { uri }) => {
    if (signals.size === 0) return query

    const inputConfig = getOr(null, 'inputConfig', query)
    const signalUri = query.get('signal')
    const signal = signals.get(signalUri)

    const scalingQueryWithSignal = mergeConditionWithSignal(
      query,
      signal,
      inputConfig
    )

    const selectedInputDescription = path(
      [signalUri, 'description'],
      inputDescriptions
    )

    return scalingQueryWithSignal.merge(
      Map({
        selectedInputDescription,
      })
    )
  }
)

export const getScalingQuerySelector = createSelector(
  scalingQueryWithSignalSelector,
  safeToJS
)
export const makeGetScalingQuerySelector = () => getScalingQuerySelector

const scalingQueryPropSelector = (key) => (state, { uri }) =>
  state.getIn(['feature', 'currentFeature', 'conditions', uri, key])

export const getScalingQueryProps = createStructuredSelector({
  valueMin: scalingQueryPropSelector('valueMin'),
  valueMax: scalingQueryPropSelector('valueMax'),
  signal: scalingQueryPropSelector('signal'),
  inputConfig: scalingQueryPropSelector('inputConfig'),
  subType: scalingQueryPropSelector('subType'),
  numberOfBits: scalingQueryPropSelector('numberOfBits'),
  startBit: scalingQueryPropSelector('startBit'),
  canId: scalingQueryPropSelector('canId'),
})

export const makeGetScalingQueryProps = () => getScalingQueryProps
